import { Tab } from "../helper-classes/Tab";
import { CrewTypes } from "../constants/enums";
import { CrewIcons } from "./icon-maps";

export const crewsIndexTabs = [
  new Tab(
    "landscape",
    CrewTypes.LANDSCAPE,
    `${CrewIcons[CrewTypes.LANDSCAPE]} text-green`
  ),
  new Tab(
    "masonry",
    CrewTypes.MASONRY,
    `${CrewIcons[CrewTypes.MASONRY]} text-red`
  ),
  new Tab(
    "lighting",
    CrewTypes.LIGHTING,
    `${CrewIcons[CrewTypes.LIGHTING]} text-yellow`
  ),
  new Tab(
    "subcontractor",
    CrewTypes.SUBCONTRACTOR,
    `${CrewIcons[CrewTypes.SUBCONTRACTOR]} text-purple`
  )
];
export const crewShowTabs = [
  new Tab("laborers", "laborers", "fal fa-users fa-fw", 3),
  new Tab("notes", "notes", "fal fa-sticky-note fa-fw", 3)
];
